<uis-slider ngSkipHydration [items]="data.content.items" [itemsToShow]="1">
	<ng-template let-item="item" let-isCurrentItem="isCurrentItem">
		<div class="banner">
			<uis-basic-banner (buttonClick)="handleBannerEvent($event)" [banner]="item"></uis-basic-banner>
		</div>
	</ng-template>
</uis-slider>
